import api from './axios';

const BASE = '/products';

export const getProducts = (page = 0, size = 10, filters = {}) =>
  api.get(BASE, { params: { page, size, ...filters } });

export const getProduct = (id) => api.get(`${BASE}/${id}`);

export const createProduct = (data) => api.post(BASE, data);

export const updateProduct = (id, data) => api.put(`${BASE}/${id}`, data);

export const deleteProduct = (id) => api.delete(`${BASE}/${id}`);

export const toggleProductActive = (id) => api.patch(`${BASE}/${id}/toggle-active`);

export const getProductCostHistory = (id) => api.get(`${BASE}/${id}/cost-history`);

export const uploadProductImage = (productId, file) => {
  const formData = new FormData();
  formData.append('file', file);
  return api.post(`${BASE}/${productId}/images`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
};

export const deleteProductImage = (productId, imageId) =>
  api.delete(`${BASE}/${productId}/images/${imageId}`);

export const reorderProductImages = (productId, imageIds) =>
  api.put(`${BASE}/${productId}/images/reorder`, { imageIds });

export const getProductStructure = () => api.get('/product-structure');

export const saveProductStructure = (fields) => api.put('/product-structure', { fields });

export const getProductVariants = (productId) => api.get(`${BASE}/${productId}/variants`);
